import API from '@/tool/api';
import request from '@/tool/request';
import { unwrapResult } from '@/tool/result';

export default {
    async accessUrl(reviewId, imageId) {
        return unwrapResult(await request.get(API.serviceReviews.accessUrl(reviewId, imageId)), '图片暂时无法读取');
    },
    async submit(serviceOrderNo, { score, text, files = [] }) {
        const body = new FormData();
        body.append('score', String(score));
        body.append('text', text);
        files.forEach(file => body.append('files', file));
        const summary = unwrapResult(await request.post(API.serviceReviews.submit(serviceOrderNo), body), '评价提交失败，请稍后重试');
        if (!summary || summary.status !== 1) throw new Error('评价保存结果未确认，请刷新状态');
        return summary;
    },
    async list(professionalType, professionalId, pageNo = 1) {
        return unwrapResult(await request.get(API.serviceReviews.list(professionalType, professionalId), {
            params: { pageNo, pageSize: 20 },
        }), '评价加载失败，请稍后重试');
    },
};
